import crews from "csi/access/crews";
import { REVISION_DRAFT } from "csi/reflection/reflectionConstants";
import { routerStore } from "csi/state/rootStore";
import ToolbarPluginButton from "csi/view/ToolbarPluginButton";
import declare from "dojo/_base/declare";

const UpdateRecipeLabelPlugin = declare(ToolbarPluginButton, {
	/**
	 * @override
	 * C8FB-12: Recipe's "Update Recipe Label" action to be available to user with Food Label Data Sheet Editor roles
	 */
	validatePlugin(ctx) {
		return crews.isInRoles(["Product Specification Administrator", "TDS - Food Label Administrator", "TDS - Food Label Editor", "TDS - Food Label Creator", "Product Specification Editor"], ctx.getContextNode());
	},

	/**
	 * @override
	 * On RecipeDataSheet view, disable the "UpdateRecipeLabel" buttons if RecipeDataSheetRevision in view is not DRAFT
	 */
	enablePlugin(ctx) {
		const revisionNode = routerStore.locationRevisionNode;
		if (revisionNode?.$Type === "RecipeDataSheetRevision") {
			this._setDisabled(this, revisionNode.State != REVISION_DRAFT);
		}
	},
});

export = UpdateRecipeLabelPlugin;